export enum OptionState {
  DEFAULT = 'default',
  SELECTED = 'selected',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  MUTED = 'muted'
}

export interface OptionCss {
  base?: string;
  letter?: string;
  text?: string;
  state?: Partial<Record<OptionState, string>>;
  letterState?: Partial<Record<OptionState, string>>;
}

export interface QuestionCss {
  container?: string;
  title?: string;
  list?: string;
  option?: OptionCss;
}
